export function downloadXls(response: any) {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${Date.now()}.xlsx`)
    document.body.appendChild(link)
    link.click()
}
